import { imageLoadingPolyfill } from './loading-polyfill/image-loading-polyfill';

imageLoadingPolyfill.registerCustomEvent('PAGE_LOADED');
imageLoadingPolyfill.registerCustomEvent('LAYER_LOADED');
imageLoadingPolyfill.registerCustomEvent('ONELAYER_LOADED');
imageLoadingPolyfill.registerCustomEvent('content_rendered');

export { imageLoadingPolyfill };
